module.exports = __webpack_public_path__ + "static/img/p1-1.0918dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-1.png
// module id = KDov
// module chunks = 0